import { DateTime } from "luxon";
import { createRoot } from "react-dom/client";
import {
	BrowserRouter as Router,
	Route,
	Switch,
	useHistory,
} from "react-router-dom";
import "../../css/dashboard.scss";
import { trpc } from "../dashboard/utils/trpc";
import { WithNonAuthedTrpcClient } from "../misc/with-non-authed-trpc-client";
import { PublicAvailabilityPoll } from "./components/availability-poll";
import { AppTimeFinder } from "./components/time_finder";

// Updated interface to support multiple time slots per day
interface TimeSlot {
	startTime: DateTime;
	endTime?: DateTime;
}

// Interface for a date with multiple time slots
interface SelectedDate {
	date: DateTime; // Date only (no time component)
	timeSlots: TimeSlot[]; // Array of time slots for this date
}

window.onload = () => {
	const container = document.getElementById("time-finder");
	const root = createRoot(container);
	root.render(
		<WithNonAuthedTrpcClient>
			<Router>
				<NonDashboardApp />
			</Router>
		</WithNonAuthedTrpcClient>
	);
};

function NonDashboardApp() {
	const history = useHistory();
	const mutation = trpc.time_finder.createPublic.useMutation({
		onSuccess: (data) => {
			history.push(`/time-finder/view/${data.time_finder_instance_id}`);
		},
	});

	return (
		<Switch>
			<Route exact path="/time-finder">
				<AppTimeFinder
					is_loading={mutation.isLoading}
					onSubmit={mutation.mutate}
					is_public={true}
					is_on_dashboard={false}
					does_have_premium={false}
				/>
			</Route>
			<Route path="/time-finder/view/:timeFinderID">
				<PublicAvailabilityPoll />
			</Route>
		</Switch>
	);
}
